import BasketLine from 'app/components/checkout/steps/partials/BasketLine'
import PaymentTerms from 'app/components/checkout/steps/partials/PaymentTerms'
import InvoiceTerms from 'app/components/checkout/steps/partials/InvoiceTerms'
import Step from 'app/components/checkout/steps/Step'
import AlcoholTerms from 'app/components/checkout/steps/partials/AlcoholTerms'
import TermAccordion from 'app/components/checkout/steps/partials/TermAccordion'

const env      = require('app/services/env')
const Selector = require('app/components/checkout/steps/payment/Selector')
const Trans = require('app/components/trans/Trans')
const {numberFormat} = require("app/util/formaters");

export default class PaymentType extends Step {

  get defaultState () {

    return {
      paymentType: this.props.cart.paymentType || 'bambora'
    }
  }

  /////////////////////////////////
  // Basic getters
  /////////////////////////////////

  get title () {
    return translate('Betalingsoplysninger')
  }

  get description () {
    return (
      <span><Trans>Vælg en betalingsmetode</Trans></span>
    )
  }

  get baseClassName () {
    return 'step-payment-type'
  }

  get gaInfo () {
    return {
      'page_title': translate('Ser betalingsmuligheder'),
      'page_path':  translate('/ser-betalingsmuligheder/')
    }
  }

  get nextActionLabel () {
    // payment types where payment module is needed
    return this.paymentTypeIsCreditCard() ? translate('Gå til betaling') : translate('Gennemfør ordre')
  }

  get nextButtonProps () {
    return { displayLoader: true }
  }

  /////////////////////////////////
  // Assorted helpers
  /////////////////////////////////

  onFocus () {

    if (this.paymentTerms) {
      this.paymentTerms.reset()
    }

    if (this.invoiceTerms) {
      this.invoiceTerms.reset()
    }

  }

  buildPayload () {
    let data = {
      payment_type:           this.state.paymentType,
      accepted_terms:         this.paymentTerms.hasAccepted() ? 1 : 0,
      accepted_invoice_terms: (this.invoiceTerms && this.invoiceTerms.hasAccepted()) ? 1 : 0
    }

    let payload

    if (this.stepElement) {
      const form = this.stepElement.querySelector('form')

      if (form) {
        payload = new FormData(form)
      }
    }

    if (typeof (payload) === 'undefined') {
      payload = new FormData()
    }

    Object.keys(data).forEach(key => {
      payload.append(key, data[key])
    })

    return payload
  }

  onNext () {
    return new Promise((resolve, reject) => {

      if (!this.alcoholTerms.hasAccepted()) {
        return this.setState({
          error:      translate('Du skal være over 16 år, før du kan bestille ordren'),
          submitting: false
        }, () => {
          reject()
        })
      }

      let acceptedTerms = this.paymentTerms.hasAccepted()

      if (this.paymentTypeIsAnyInvoiceType() && !this.invoiceTerms.hasAccepted()) {
        acceptedTerms = false
      }

      if (!acceptedTerms) {
        this.setState({
          error:      translate('Accepter venligst vilkårene og betingelserne, før du bestiller ordren.'),
          submitting: false
        }, () => {
          reject()
        })
      } else {
        this.pipelines.order.place.dispatch(this.buildPayload()).catch(error => {

          const errors = error.response.data.errors
          const keys   = Object.keys(errors)

          this.setState({
            error: errors[keys[0]][0]
          }, () => {
            reject()
          })

          throw error
        })
      }

    })
  }

  /////////////////////////////////
  // Event helpers
  /////////////////////////////////

  _onSelectorChange = (value) => {
    this.setState({ paymentType: value, error: null })
  }

  /////////////////////////////////
  // Payment type helpers
  /////////////////////////////////

  paymentTypeIsEanInvoice () {
    return this.state.paymentType === 'ean_invoice'
  }

  paymentTypeIsInvoice () {
    return this.state.paymentType === 'invoice'
  }

  paymentTypeIsAnyInvoiceType () {
    return this.paymentTypeIsEanInvoice() || this.paymentTypeIsInvoice()
  }

  paymentTypeIsCreditCard () {
    return ['bambora', 'mobilepay', 'viabill', 'paypal'].indexOf(this.state.paymentType) !== -1
  }

  /////////////////////////////////
  // Rendering helpers
  /////////////////////////////////

  renderFee () {
    if (!this.paymentTypeIsInvoice()) {
      return
    }

    return <BasketLine title={ translate('Gebyr') }
                       value={env.get('checkout.payment.companyInvoiceFee', 25.0)}/>
  }

  renderTotal () {
    const fee = this.paymentTypeIsInvoice() ?
      env.get('checkout.payment.companyInvoiceFee', 25.0) : 0.0

    return <BasketLine title={ translate('At betale') }
                       value={this.cart.price.total + fee}/>
  }

  renderInvoiceTerms () {

    if (!this.paymentTypeIsAnyInvoiceType()) {
      return
    }

    return <InvoiceTerms ref={ref => this.invoiceTerms = ref}
                         onChange={this.resetErrors}
                         className="alchohol-checkbox"/>
  }

  toggleTermAccordion = e => {
    const clickedElement = e.currentTarget
    const toggleElement  = clickedElement.querySelector('.contact-content')
    const contentElement = clickedElement.querySelector('.contact-content-inner')

    if (!toggleElement.style.maxHeight) {
      toggleElement.style.maxHeight = contentElement.offsetHeight + 'px'
      clickedElement.classList.add('open')
    } else {
      toggleElement.style.maxHeight = ''
      clickedElement.classList.remove('open')
    }
  }

  isFuneral () {
    return this.cart.productType === 'funeral'
  }

  renderTermAccordions () {
    return (
      <div className="term-accordions">
        {this.isFuneral() && (
          <TermAccordion title={ translate("Oplysninger om begravelse")} >
            <p> <Trans> Ved levering til begravelse, garanterer vi altid levering til
              tiden, forudsat bestillingen er afgivet i overensstemmelse med
              vores salgs- og leveringsbetingelser. </Trans> </p>
          </TermAccordion>
        )}
        <TermAccordion title={ translate("Oplysninger om levering") } >
          <p> <Trans>Ved levering på et bestemt tidspunkt på dagen ved øvrige ordrer,
            garanterer vi ikke, at der sker levering på det ønskede tidspunkt på
            dagen, men vi gør alt hvad der er muligt for at opfylde ønsket
            herom.</Trans> </p>
          <p> <Trans>Ved levering tages der forbehold for ekstreme vejrsituationer som
            fx sne, is og vejrlig i øvrigt.</Trans> </p>
        </TermAccordion>
      </div>
    )
  }

  renderOrderFooter () {
    return (
      <div className="order-footer hide-desktop"
           style={{ transform: `translateX(400%)` }}>
        <div className="order-footer__content">
          <div>
            <div className="order-footer__title">Varer
              - {numberFormat(this.cart.price.subtotal)}
            </div>
            <div
              className="order-footer__subtitle">{this.cart.price.delivery <= 0 ? translate('Afhentning') : translate('Udbringning')} - {numberFormat(this.cart.price.delivery)}
            </div>
          </div>
          <div className="order-footer__border">
          </div>
          <div className="order-footer__price">
            {numberFormat(this.cart.price.total)}
          </div>
          <div>
            <button onClick={() => this.next()}>
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderStep () {
    return (
      <div>
        <Selector ref={el => this.selector = el} value={this.state.paymentType}
                  cart={this.cart}
                  onChange={this._onSelectorChange}/>
        <div className="price-lines">
          {this.renderFee()}
          {this.renderTotal()}
        </div>
        <div className="inputs terms-inputs">
          {this.renderInvoiceTerms()}
          <AlcoholTerms ref={ref => this.alcoholTerms = ref}
                        onChange={this.resetErrors}
                        className="alchohol-checkbox"/>
          {this.renderTermAccordions()}
          <PaymentTerms ref={ref => this.paymentTerms = ref}
                        onChange={this.resetErrors}
                        className="alchohol-checkbox terms-checkbox"/>
        </div>
        {this.renderError()}
        {this.renderOrderFooter()}
      </div>
    )
  }

}
